function isAbortLikeError(value: any): boolean {
  if (!value || typeof value !== "object") return false;

  const name = typeof value.name === "string" ? value.name.toLowerCase() : "";
  const code = typeof value.code === "string" ? value.code.toLowerCase() : "";
  const type = typeof value.type === "string" ? value.type.toLowerCase() : "";
  const message = typeof value.message === "string" ? value.message.toLowerCase().trim() : "";

  if (name === "aborterror" || code === "abort_err" || type === "aborted") {
    return true;
  }

  return (
    message === "aborted" ||
    message === "the operation was aborted" ||
    message === "signal is aborted without reason" ||
    message.includes("bodystreambuffer was aborted")
  );
}

export function isAbortLikePersistentChatStreamError(error: any): boolean {
  return isAbortLikeError(error) || isAbortLikeError(error?.cause);
}

export function isExpectedPersistentChatStreamError(error: any): boolean {
  if (isAbortLikePersistentChatStreamError(error)) {
    return true;
  }

  if (!error || typeof error !== "object") {
    return false;
  }

  // The streaming API sends ordinary user-visible failures as data chunks shaped
  // like `{ error, message }`. Those still drive chat error UI, but they are not
  // useful frontend exceptions to group in Sentry.
  return Boolean(error.error && typeof error.message === "string" && error.message.trim());
}

export function shouldCapturePersistentChatStreamError(error: any): boolean {
  return !isExpectedPersistentChatStreamError(error);
}
